import { Log } from 'probe.gl';
export default new Log({
  id: 'deck'
});
//# sourceMappingURL=log.js.map


// WEBPACK FOOTER //
// ./~/@deck.gl/core/dist/esm/utils/log.js